import { j as isMobile, k as isIOS, t as trustWallet, e as binanceWallet, d as isWalletConnect, o as openLink, b as isTMA, a as getEvmGlobalData, s as setEvmGlobalData } from '../chunks/chunk.js';
export { c as isAndroid, m as isLargeIOS, l as isSmallIOS } from '../chunks/chunk.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import React, { useContext, useMemo, useState, useEffect, useCallback, useRef } from 'react';
import { WagmiProvider, useAccount, useConnectors, useConnect, useDisconnect, useChains, useSwitchChain } from 'wagmi';
import { ConnectionProvider, WalletProvider, useWallet } from '@solana/wallet-adapter-react';
import { useWallet as useWallet$1, WalletProvider as WalletProvider$1 } from '@tronweb3/tronwallet-adapter-react-hooks';
import { createPortal } from 'react-dom';
import QRCodeUtil from 'qrcode';
import '../chunks/chunk2.js';
import 'wagmi/connectors';
import 'viem';

function cx(...classNames) {
  if (!classNames.length)
    return;
  return classNames.filter(Boolean).join(" ");
}
function cssVar(name, type = "colors") {
  return `var(--wk-${type}-${name.replace(/\./g, "-")})`;
}
function rgba(firstValue, secondValue, thirdValue, fourthValue = 1) {
  if (typeof firstValue === "string") {
    if (firstValue.startsWith("#")) {
      const hexStr = firstValue.slice(1);
      const formatStr = hexStr.length === 3 ? hexStr.replace(/[A-F\d]/gi, "$&$&") : hexStr;
      const hexArr = formatStr.match(/.{2}/g)?.map((v) => parseInt(v, 16));
      if (hexArr?.length === 3) {
        return rgba(hexArr[0], hexArr[1], hexArr[2], secondValue);
      }
    }
  }
  return `rgba(${firstValue}, ${secondValue}, ${thirdValue}, ${fourthValue})`;
}

const radii = {
  common: "8px",
  modal: "12px",
  navButton: "4px",
  button: "var(--wk-radii-common)",
  connectButton: "var(--wk-radii-common)",
  disconnectButton: "var(--wk-radii-common)",
  noWalletButton: "var(--wk-radii-common)",
  walletOption: "var(--wk-radii-common)",
  walletOptionIcon: "var(--wk-radii-common)",
  chainOption: "var(--wk-radii-common)",
  toast: "var(--wk-radii-common)",
  qrCode: "var(--wk-radii-common)"
};
const zIndices = {
  modal: 1300,
  toast: 1500
};
const base = {
  light: {
    colors: {
      text: "#1E2026",
      textSecondary: "#76808F",
      primary: "#CC9D09",
      primaryActive: "#F0B90B",
      error: "#D9304E",
      errorActive: "#B82942",
      border: "#E6E8EA",
      disabled: "#AEB4BC",
      modalBackground: "#FFFFFF",
      modalOverlay: "rgba(0, 0, 0, 0.5)",
      buttonText: "var(--wk-colors-text)",
      buttonTextHover: "var(--wk-colors-text)",
      buttonBackground: "#f5f5f5",
      buttonBackgroundHover: rgba("#F0B90B", 0.1),
      connectButtonText: "var(--wk-colors-text)",
      connectButtonTextHover: "var(--wk-colors-text)",
      connectButtonBackground: "#f5f5f5",
      connectButtonBackgroundHover: "#e6e8ea",
      navButtonText: "var(--wk-colors-textSecondary)",
      navButtonBackgroundHover: "var(--wk-colors-border)",
      optionText: "var(--wk-colors-text)",
      optionTextHover: "var(--wk-colors-text)",
      optionBackground: "#f5f5f5",
      optionBackgroundHover: rgba("#F0B90B", 0.1),
      walletOptionText: "var(--wk-colors-optionText)",
      walletOptionTextHover: "var(--wk-colors-optionTextHover)",
      walletOptionBackground: "var(--wk-colors-optionBackground)",
      walletOptionBackgroundHover: "var(--wk-colors-optionBackgroundHover)",
      chainOptionText: "var(--wk-colors-optionText)",
      chainOptionTextHover: "var(--wk-colors-optionTextHover)",
      chainOptionBackground: "var(--wk-colors-optionBackground)",
      chainOptionBackgroundHover: "var(--wk-colors-optionBackgroundHover)",
      toastBackground: "var(--wk-colors-modalBackground)",
      qrCodeDot: "var(--wk-colors-text)",
      qrCodeBorder: "var(--wk-colors-border)",
      noWalletButtonText: "var(--wk-colors-text)",
      noWalletButtonTextHover: "var(--wk-colors-text)",
      noWalletButtonBackground: "transparent",
      noWalletButtonBackgroundHover: "var(--wk-colors-border)",
      noWalletButtonBorder: "var(--wk-colors-border)",
      noWalletButtonBorderHover: "var(--wk-colors-border)",
      disconnectButtonBackgroundText: "var(--wk-colors-text)",
      disconnectButtonBackgroundTextHover: "var(--wk-colors-text)",
      disconnectButtonBackground: "transparent",
      disconnectButtonBackgroundHover: "var(--wk-colors-border)",
      disconnectButtonBorder: "var(--wk-colors-border)",
      disconnectButtonBorderHover: "var(--wk-colors-border)"
    },
    shadows: {
      normal: "0px 4px 20px 0px rgba(0, 0, 0, 0.04)",
      toast: "0px 4px 24px rgba(0, 0, 0, 0.08)"
    },
    radii,
    zIndices
  },
  dark: {
    colors: {
      text: "#FFF",
      textSecondary: "#76808F",
      primary: "#CC9D09",
      primaryActive: "#F0B90B",
      error: "#D9304E",
      errorActive: "#B82942",
      border: "#2e323a",
      disabled: "#5E6673",
      modalBackground: "#1E2026",
      modalOverlay: rgba("#000", 0.5),
      buttonText: "var(--wk-colors-text)",
      buttonTextHover: "var(--wk-colors-text)",
      buttonBackground: "#14151a",
      buttonBackgroundHover: rgba("#F0B90B", 0.1),
      connectButtonText: "var(--wk-colors-text)",
      connectButtonTextHover: "var(--wk-colors-text)",
      connectButtonBackground: "#2b2f36",
      connectButtonBackgroundHover: "#2e323a",
      navButtonText: "var(--wk-colors-textSecondary)",
      navButtonBackgroundHover: "var(--wk-colors-border)",
      optionText: "var(--wk-colors-text)",
      optionTextHover: "var(--wk-colors-text)",
      optionBackground: "#14151a",
      optionBackgroundHover: rgba("#F0B90B", 0.1),
      walletOptionText: "var(--wk-colors-optionText)",
      walletOptionTextHover: "var(--wk-colors-optionTextHover)",
      walletOptionBackground: "var(--wk-colors-optionBackground)",
      walletOptionBackgroundHover: "var(--wk-colors-optionBackgroundHover)",
      chainOptionText: "var(--wk-colors-optionText)",
      chainOptionTextHover: "var(--wk-colors-optionTextHover)",
      chainOptionBackground: "var(--wk-colors-optionBackground)",
      chainOptionBackgroundHover: "var(--wk-colors-optionBackgroundHover)",
      toastBackground: "var(--wk-colors-modalBackground)",
      qrCodeDot: "var(--wk-colors-text)",
      qrCodeBorder: "var(--wk-colors-border)",
      noWalletButtonText: "var(--wk-colors-text)",
      noWalletButtonTextHover: "var(--wk-colors-text)",
      noWalletButtonBackground: "transparent",
      noWalletButtonBackgroundHover: "var(--wk-colors-border)",
      noWalletButtonBorder: "var(--wk-colors-border)",
      noWalletButtonBorderHover: "var(--wk-colors-border)",
      disconnectButtonBackgroundText: "var(--wk-colors-text)",
      disconnectButtonBackgroundTextHover: "var(--wk-colors-text)",
      disconnectButtonBackground: "transparent",
      disconnectButtonBackgroundHover: "var(--wk-colors-border)",
      disconnectButtonBorder: "var(--wk-colors-border)",
      disconnectButtonBorderHover: "var(--wk-colors-border)"
    },
    shadows: {
      normal: "0px 4px 20px 0px rgba(0, 0, 0, 0.04)",
      toast: "0px 4px 24px rgba(0, 0, 0, 0.08)"
    },
    radii,
    zIndices
  }
};

function isObject(item) {
  return item && typeof item === "object" && !Array.isArray(item) && item !== null;
}
function deepMerge(target, source) {
  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key])
          Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }
  return target;
}

const ThemeContext = React.createContext({});
function useTheme() {
  return useContext(ThemeContext);
}

const themeMap = {
  base
};
function ThemeProvider(props) {
  const { variant = "base", mode = "auto", theme, children } = props;
  const styleContent = useMemo(() => {
    const lightTheme = deepMerge(themeMap[variant].light ?? theme, theme?.light ?? theme);
    const darkTheme = deepMerge(themeMap[variant].dark ?? theme, theme?.dark ?? theme);
    const lightCssVars = createCssVars(lightTheme, "--wk-light");
    const darkCssVars = createCssVars(darkTheme, "--wk-dark");
    const lightPointer = createPointer(lightCssVars);
    const darkPointer = createPointer(darkCssVars);
    const lightCssVarsContent = createStyleContent(lightCssVars);
    const darkCssVarsContent = createStyleContent(darkCssVars);
    const lightPointerContent = createStyleContent(lightPointer);
    const darkPointerContent = createStyleContent(darkPointer);
    if (mode === "light") {
      return `body {
        ${lightPointerContent};
        ${lightCssVarsContent};
      }`;
    }
    if (mode === "dark") {
      return `body {
        ${darkPointerContent};
        ${darkCssVarsContent};
      }`;
    }
    if (mode === "auto") {
      return `body {
        ${lightCssVarsContent};
        ${darkCssVarsContent};
        @media (prefers-color-scheme: light) {
          ${lightPointerContent};
        }
        @media (prefers-color-scheme: dark) {
          ${darkPointerContent};
        }
      }`;
    }
    return "";
  }, [theme, mode, variant]);
  const [colorMode, setColorMode] = useState("light");
  useEffect(() => {
    if (mode === "auto") {
      const matchMedia = window.matchMedia("(prefers-color-scheme: dark)");
      const onChange = () => {
        const cm = matchMedia.matches ? "dark" : "light";
        setColorMode(cm);
      };
      onChange();
      matchMedia.addEventListener("change", onChange);
      return () => {
        matchMedia.removeEventListener("change", onChange);
      };
    } else {
      setColorMode(mode);
    }
  }, [mode]);
  const value = useMemo(() => {
    return {
      colorMode
    };
  }, [colorMode]);
  return /* @__PURE__ */ jsxs(ThemeContext.Provider, { value, children: [
    /* @__PURE__ */ jsx("style", { children: styleContent }),
    children
  ] });
}
function createCssVars(theme, prefix = "") {
  const cssVars = {};
  const walk = (input, prefix2 = "") => {
    Object.entries(input).forEach(([key, value]) => {
      const varName = `${prefix2}-${key}`;
      if (typeof value !== "object") {
        cssVars[varName] = value;
      } else {
        walk(value, varName);
      }
    });
  };
  walk(theme, prefix);
  return cssVars;
}
function createStyleContent(cssVars) {
  return Object.entries(cssVars).map(([key, value]) => {
    return `${key}: ${value}`;
  }).join(";");
}
function createPointer(cssVars) {
  const pointers = {};
  Object.keys(cssVars).forEach((item) => {
    const key = item.replace(/\-light|\-dark/g, "");
    const value = `var(${item})`;
    pointers[key] = value;
  });
  return pointers;
}

const WalletKitContext = React.createContext({});
function useWalletKit() {
  return useContext(WalletKitContext);
}

function EvmWalletProvider(props) {
  const { children } = props;
  const { evmConfig } = useWalletKit();
  if (!evmConfig) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsx(WagmiProvider, { config: evmConfig.wagmiConfig, reconnectOnMount: evmConfig.autoConnect, children });
}

class CustomEventEmitter {
  listenersMap;
  constructor() {
    this.listenersMap = {};
  }
  on(event, cb) {
    if (!this.listenersMap[event])
      this.listenersMap[event] = [];
    this.listenersMap[event].push(cb);
  }
  emit(event, ...params) {
    const listener = this.listenersMap[event];
    if (listener) {
      listener.forEach((cb) => cb(...params));
    }
  }
  off(event, cb) {
    const listeners = this.listenersMap[event];
    if (listeners) {
      const index = listeners.findIndex((item) => item === cb);
      if (index > -1) {
        listeners.splice(index);
      }
    }
  }
  EVM_CONNECT_ERROR = "EVM_CONNECT_ERROR";
  EVM_CONNECT_SETTLE = "EVM_CONNECT_SETTLE";
  SOLANA_WALLET_ERROR = "SOLANA_WALLET_ERROR";
  TRON_WALLET_ERROR = "TRON_WALLET_ERROR";
}
const EventEmitter = new CustomEventEmitter();

function SolanaWalletProvider(props) {
  const { children } = props;
  const { solanaConfig } = useWalletKit();
  const onError = useCallback((error) => {
    EventEmitter.emit(EventEmitter.SOLANA_WALLET_ERROR, error);
  }, []);
  if (!solanaConfig) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsx(ConnectionProvider, { endpoint: solanaConfig.rpcUrl, children: /* @__PURE__ */ jsx(
    WalletProvider,
    {
      wallets: solanaConfig.adapters,
      onError,
      autoConnect: solanaConfig.autoConnect,
      children
    }
  ) });
}

const ToastManager = {
  listeners: [],
  toastList: [],
  autoIncreaseId: 0,
  add(options) {
    const toastId = this.autoIncreaseId++;
    this.toastList.unshift({
      toastId,
      ...options
    });
    this.notify();
    return toastId;
  },
  remove(toastId) {
    const index = this.toastList.findIndex((item) => item.toastId === toastId);
    if (index > -1) {
      this.toastList.splice(index, 1);
      this.notify();
    }
  },
  notify() {
    this.listeners.forEach((fn) => {
      fn([...this.toastList]);
    });
  },
  subscribe(fn) {
    this.listeners.push(fn);
  },
  unsubscribe(fn) {
    const index = this.listeners.findIndex((item) => item === fn);
    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  }
};

const toast = (props) => {
  const { variant = "info", duration = 3e3, ...restProps } = props;
  return ToastManager.add({
    variant,
    duration,
    ...restProps
  });
};
toast.info = (props) => {
  return toast({ variant: "info", ...props });
};
toast.error = (props) => {
  return toast({ variant: "error", ...props });
};

function getDefaultConfig(config) {
  const { options, evmConfig, solanaConfig, tronConfig } = config;
  return {
    options: {
      title: "Connect Wallet",
      disclaimer: void 0,
      gridLayoutThreshold: 6,
      useGridLayoutOnMobile: true,
      hideNoWalletCTA: false,
      hideOfficialWalletConnectCTA: true,
      walletDownloadUrl: `https://trustwallet.com/`,
      closeModalAfterSwitchingNetwork: true,
      closeModalAfterConnected: true,
      closeModalOnEsc: true,
      closeModalOnOverlayClick: true,
      openModalOnWrongNetwork: false,
      onError(_err, description) {
        if (description) {
          toast.error({
            description
          });
        }
      },
      ...options
    },
    evmConfig,
    solanaConfig,
    tronConfig
  };
}

const RouteContext = React.createContext({});
function useRouter() {
  return useContext(RouteContext);
}

var CONNECT_STATUS = /* @__PURE__ */ ((CONNECT_STATUS2) => {
  CONNECT_STATUS2["CONNECTED"] = "connected";
  CONNECT_STATUS2["CONNECTING"] = "connecting";
  CONNECT_STATUS2["FAILED"] = "failed";
  CONNECT_STATUS2["REJECTED"] = "rejected";
  CONNECT_STATUS2["NOTCONNECTED"] = "notconnected";
  CONNECT_STATUS2["UNAVAILABLE"] = "unavailable";
  return CONNECT_STATUS2;
})(CONNECT_STATUS || {});

const styles_css_ts_vanilla$r = '';

var clsBox = "wk_t59jcv0";

const Box = React.forwardRef((props, ref) => {
  const { as = "div", className, ...restProps } = props;
  return React.createElement(as, {
    ref,
    className: cx(clsBox, className),
    ...restProps
  });
});
Box.displayName = "Box";

const styles_css_ts_vanilla$q = '';

var clsButton$1 = "wk_14j9dar0";

const Button = React.forwardRef((props, ref) => {
  const { className, ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { ref, as: "button", className: cx("wk-button", clsButton$1, className), ...restProps });
});
Button.displayName = "Button";

const styles_css_ts_vanilla$p = '';

var clsModalBody = "wk_vno40y0";

function ModalBody(props) {
  const { className, ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { className: cx("wk-modal-body", clsModalBody, className), ...restProps });
}

const styles_css_ts_vanilla$o = '';

var clsModalFooter = "wk_1rmpmq20";

function ModalFooter(props) {
  const { className, ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { className: cx("wk-modal-footer", clsModalFooter, className), ...restProps });
}

const styles_css_ts_vanilla$n = '';

var clsModalHeader = "wk_qhb85j0";

function ModalHeader(props) {
  const { className, ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { className: cx("wk-modal-header", clsModalHeader, className), ...restProps });
}

function CircleLoadingIcon(props) {
  const { thickness, endColor, ...restProps } = props;
  const startStopColor = cssVar("modalBackground");
  const endStopColor = endColor ?? cssVar("primaryActive");
  return /* @__PURE__ */ jsxs("svg", { width: "52", height: "102", viewBox: "0 0 52 102", fill: "none", ...restProps, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1 101C28.6142 101 51 78.6142 51 51C51 23.3858 28.6142 1 1 1",
        stroke: "url(#paint0_linear_1252_60553)",
        strokeWidth: thickness,
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
      "linearGradient",
      {
        id: "paint0_linear_1252_60553",
        x1: "1",
        y1: "1",
        x2: "0.999999",
        y2: "101",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ jsx("stop", { stopColor: startStopColor }),
          /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: endStopColor })
        ]
      }
    ) })
  ] });
}

const styles_css_ts_vanilla$m = '';

var clsContainer$6 = "wk_107z37f0";
var clsErrorCircle = "wk_107z37f2";
var clsLoading$1 = "wk_107z37f4";
var clsLogo = "wk_107z37f1";

function ConnectSpinner(props) {
  const {
    className,
    isLoading = false,
    isError = false,
    thickness = 2,
    loadingColor,
    children,
    ...restProps
  } = props;
  return /* @__PURE__ */ jsxs(Box, { className: cx("wk-connect-spinner", clsContainer$6, className), ...restProps, children: [
    isLoading && /* @__PURE__ */ jsx(CircleLoadingIcon, { className: clsLoading$1, thickness, endColor: loadingColor }),
    isError && /* @__PURE__ */ jsx(Box, { className: clsErrorCircle }),
    /* @__PURE__ */ jsx(Box, { className: clsLogo, children })
  ] });
}

const styles_css_ts_vanilla$l = '';

var clsContent$2 = "wk_1nr7e5q0";

function Content(props) {
  const { className, ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { className: cx("wk-content", clsContent$2, className), ...restProps });
}

const styles_css_ts_vanilla$k = '';

var clsDescription$1 = "wk_1cxzn9q0";

function Description(props) {
  const { className, ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { className: cx("wk-description", clsDescription$1, className), ...restProps });
}

const AlertIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 15", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M1.63937 12.5331L7.6704 2.47023C8.04617 1.84325 8.95383 1.84326 9.3296 2.47023L15.3606 12.5331C15.7475 13.1787 15.283 14 14.531 14H2.46897C1.71695 14 1.25246 13.1787 1.63937 12.5331Z",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.5 11.7231C9.5 12.2754 9.05228 12.7231 8.5 12.7231C7.94772 12.7231 7.5 12.2754 7.5 11.7231C7.5 11.1709 7.94772 10.7231 8.5 10.7231C9.05228 10.7231 9.5 11.1709 9.5 11.7231Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M7.6684 5.65882C7.63842 5.15178 8.01942 4.72314 8.50008 4.72314C8.98075 4.72314 9.36174 5.15178 9.33176 5.65882L9.12831 9.09936C9.10757 9.44999 8.83247 9.72314 8.50008 9.72314C8.16769 9.72314 7.89259 9.44999 7.87186 9.09936L7.6684 5.65882Z",
        fill: "currentColor"
      }
    )
  ] });
};

const styles_css_ts_vanilla$j = '';

var clsErrorTitle = "wk_ebg9wh0";

function ErrorTitle(props) {
  const { className, children, ...restProps } = props;
  return /* @__PURE__ */ jsxs(Box, { className: cx("wk-error-title", clsErrorTitle, className), ...restProps, children: [
    /* @__PURE__ */ jsx(AlertIcon, {}),
    children
  ] });
}

const styles_css_ts_vanilla$i = '';

var clsInfoTitle = "wk_pb4clz0";

function InfoTitle(props) {
  const { className, children, ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { className: cx("wk-info-title", clsInfoTitle, className), ...restProps, children });
}

function useWalletDownloadUrl(urls) {
  const { options } = useWalletKit();
  const url = useMemo(() => {
    const url2 = urls.default ?? options.walletDownloadUrl;
    return url2;
  }, [options.walletDownloadUrl, urls.default]);
  return url;
}

function useWalletLogos(walletLogos) {
  const { colorMode } = useTheme();
  const logos = useMemo(() => {
    const { default: defaultLogos, transparent: transparentLogos } = walletLogos ?? {};
    const defaultLogo = defaultLogos?.[colorMode] ?? defaultLogos;
    const transparentLogo = transparentLogos?.[colorMode] ?? transparentLogos ?? defaultLogo;
    return {
      default: defaultLogo,
      transparent: transparentLogo
    };
  }, [colorMode, walletLogos]);
  return logos;
}

const styles_css_ts_vanilla$h = '';

var clsButton = "wk_qfvtl92";
var clsContent$1 = "wk_qfvtl90";
var clsFooter$1 = "wk_qfvtl93";
var clsGap = "wk_qfvtl91";

const ConnectModalContext = React.createContext({});
function useConnectModal() {
  return useContext(ConnectModalContext);
}

function useAutoCloseConnectModal(isConnected, address) {
  const { options, selectedWallet } = useWalletKit();
  const router = useRouter();
  const { onClose } = useConnectModal();
  useEffect(() => {
    if (router.route !== ViewRoutes.HOME && isConnected) {
      options.onConnected?.({
        wallet: selectedWallet,
        address
      });
      if (options.closeModalAfterConnected) {
        onClose();
      }
    }
  }, [isConnected, router.route, options.closeModalAfterConnected]);
}

function TemplateConnectingView(props) {
  const { status, runConnect, onTryAgain, wallet, isConnected, address } = props;
  const { log } = useWalletKit();
  const logos = useWalletLogos(wallet.logos);
  const downloadUrl = useWalletDownloadUrl(wallet.downloadUrls);
  useEffect(() => {
    log("[ConnectingView]", `name: ${wallet?.name}, status: ${status}`);
    if (status === CONNECT_STATUS.UNAVAILABLE)
      return;
    const connectTimeout = setTimeout(runConnect, 600);
    return () => {
      clearTimeout(connectTimeout);
    };
  }, []);
  const isError = [
    CONNECT_STATUS.FAILED,
    CONNECT_STATUS.NOTCONNECTED,
    CONNECT_STATUS.REJECTED
  ].includes(status);
  const isLoading = status === CONNECT_STATUS.CONNECTING;
  useAutoCloseConnectModal(isConnected, address);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ModalHeader, { children: wallet?.name }),
    /* @__PURE__ */ jsxs(ModalBody, { className: clsContent$1, children: [
      /* @__PURE__ */ jsx(ConnectSpinner, { isLoading, isError, loadingColor: wallet.spinnerColor, children: logos.transparent }),
      /* @__PURE__ */ jsx(Box, { className: clsGap }),
      status === CONNECT_STATUS.FAILED && /* @__PURE__ */ jsxs(Content, { children: [
        /* @__PURE__ */ jsx(ErrorTitle, { children: "Connection Failed" }),
        /* @__PURE__ */ jsx(Description, { children: "Sorry, something went wrong. Please try connecting again." })
      ] }),
      status === CONNECT_STATUS.REJECTED && /* @__PURE__ */ jsxs(Content, { children: [
        /* @__PURE__ */ jsx(InfoTitle, { children: "Request Cancelled" }),
        /* @__PURE__ */ jsx(Description, { children: "You cancelled the request. Click above to try again." })
      ] }),
      status === CONNECT_STATUS.CONNECTING && /* @__PURE__ */ jsxs(Content, { children: [
        /* @__PURE__ */ jsx(InfoTitle, { children: "Requesting Connection" }),
        /* @__PURE__ */ jsxs(Description, { children: [
          "Open the ",
          wallet.name,
          " ",
          isMobile() ? "app" : "browser extension",
          " to connect your wallet."
        ] })
      ] }),
      status === CONNECT_STATUS.CONNECTED && /* @__PURE__ */ jsxs(Content, { children: [
        /* @__PURE__ */ jsx(InfoTitle, { children: "Already Connected" }),
        /* @__PURE__ */ jsx(Description, { children: "It is now okay to close this popup" })
      ] }),
      status === CONNECT_STATUS.NOTCONNECTED && /* @__PURE__ */ jsxs(Content, { children: [
        /* @__PURE__ */ jsxs(ErrorTitle, { children: [
          "Login to ",
          wallet.name
        ] }),
        /* @__PURE__ */ jsxs(Description, { children: [
          "To continue, please login to your ",
          wallet.name,
          " extension."
        ] })
      ] }),
      status === CONNECT_STATUS.UNAVAILABLE && /* @__PURE__ */ jsxs(Content, { children: [
        /* @__PURE__ */ jsxs(InfoTitle, { children: [
          "Install ",
          wallet.name
        ] }),
        /* @__PURE__ */ jsxs(Description, { children: [
          "To connect your ",
          wallet.name,
          ", install the browser extension."
        ] })
      ] })
    ] }),
    (status === CONNECT_STATUS.FAILED || status === CONNECT_STATUS.REJECTED) && /* @__PURE__ */ jsx(ModalFooter, { className: clsFooter$1, children: /* @__PURE__ */ jsx(Button, { className: cx("wk-retry-button", clsButton), onClick: onTryAgain, children: "Try Again" }) }),
    status === CONNECT_STATUS.UNAVAILABLE && /* @__PURE__ */ jsx(ModalFooter, { className: clsFooter$1, children: /* @__PURE__ */ jsx(
      Button,
      {
        className: cx("wk-download-button", clsButton),
        as: "a",
        href: downloadUrl,
        target: "_blank",
        rel: "noopener",
        children: "Install the Extension"
      }
    ) })
  ] });
}

function useIsConnected() {
  const { address } = useAccount();
  return !!address;
}

function useWalletConnector(id) {
  const connectors = useConnectors();
  return connectors.find((item) => item.id === id);
}

function evmCommonErrorHandler(props) {
  const { log, handler, error } = props;
  let text = "";
  if (error) {
    if (error.code) {
      switch (error.code) {
        case 4902:
          if (isIOS() && trustWallet().isInstalled()) {
            text = "Not supported chainId";
          }
          break;
      }
    }
    let description = text || error.cause?.message || error.message;
    if (description?.includes("Connection request reset")) {
      description = void 0;
    }
    if (isMobile() && binanceWallet().isInstalled()) {
      if (description?.includes("Request failed: The JSON sent is not a valid Request object.") || description?.includes("Adaptor not found: eip155")) {
        description = "Please update to the latest version of the Binance app and try again later.";
      }
    }
    log("[WalletError]", error);
    handler?.(error, description);
  }
}

let timer;
function useEvmConnect(props) {
  const { log, options, evmConfig } = useWalletKit();
  const connectProps = {
    chainId: evmConfig?.initialChainId
  };
  const { connect, connectAsync, connectors, ...restProps } = useConnect({
    ...props,
    mutation: {
      ...props?.mutation,
      onSettled(data, error, ...params) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          EventEmitter.emit(EventEmitter.EVM_CONNECT_SETTLE, data, error, ...params);
          props?.mutation?.onSettled?.(data, error, ...params);
          if (error) {
            evmCommonErrorHandler({
              log,
              handler: options.onError,
              error
            });
          }
        }, 100);
      }
    }
  });
  return {
    connect: ({ ...opts }) => {
      return connect({
        ...connectProps,
        ...opts
      });
    },
    connectAsync: async ({ ...opts }) => {
      return await connectAsync({
        ...connectProps,
        ...opts
      });
    },
    connectors,
    ...restProps
  };
}

function useConnectingStatus(props = {}) {
  const { initialStatus } = props;
  const { selectedWallet, evmConfig, options, action } = useWalletKit();
  const defaultStatus = selectedWallet.isInstalled() ? CONNECT_STATUS.CONNECTING : CONNECT_STATUS.UNAVAILABLE;
  const [status, setStatus] = useState(initialStatus ?? defaultStatus);
  const { connect } = useEvmConnect();
  useEffect(() => {
    const onSettled = (data, error) => {
      if (error) {
        if (error.code) {
          switch (error.code) {
            case -32002:
              setStatus(CONNECT_STATUS.NOTCONNECTED);
              break;
            case 4001:
              setStatus(CONNECT_STATUS.REJECTED);
              break;
            default:
              setStatus(CONNECT_STATUS.FAILED);
              break;
          }
        } else {
          if (error.message) {
            switch (error.message) {
              case "User rejected request":
                setStatus(CONNECT_STATUS.REJECTED);
                break;
              default:
                setStatus(CONNECT_STATUS.FAILED);
                break;
            }
          }
        }
      } else if (data) {
        if (evmConfig?.initialChainId && data.chainId === evmConfig.initialChainId && action === "add-network") {
          options.onChainAlreadyAdded?.({
            wallet: selectedWallet,
            chainId: data.chainId
          });
        }
      }
    };
    EventEmitter.on(EventEmitter.EVM_CONNECT_SETTLE, onSettled);
    return () => {
      EventEmitter.off(EventEmitter.EVM_CONNECT_SETTLE, onSettled);
    };
  }, [action, evmConfig?.initialChainId, options, selectedWallet]);
  return {
    status,
    connect,
    setStatus
  };
}

function EvmConnectingView() {
  const { selectedWallet } = useWalletKit();
  const isConnected = useIsConnected();
  const selectedConnector = useWalletConnector(selectedWallet.id);
  const { connect, status, setStatus } = useConnectingStatus();
  const { address } = useAccount();
  const runConnect = useCallback(() => {
    if (!selectedWallet.isInstalled())
      return;
    if (selectedConnector) {
      setStatus(CONNECT_STATUS.CONNECTING);
      connect({ connector: selectedConnector });
    } else {
      setStatus(CONNECT_STATUS.UNAVAILABLE);
    }
  }, [connect, selectedConnector, selectedWallet, setStatus]);
  return /* @__PURE__ */ jsx(
    TemplateConnectingView,
    {
      status,
      runConnect,
      onTryAgain: runConnect,
      wallet: selectedWallet,
      isConnected,
      address
    }
  );
}

const styles_css_ts_vanilla$g = '';

var clsLink = "wk_1a9rgw50";

const Link = (props) => {
  const { className, ...restProps } = props;
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "a",
      className: cx("wk-link", clsLink, className),
      target: "_blank",
      rel: "noopener",
      ...restProps
    }
  );
};
Link.displayName = "Link";

const ForwardIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", { width: "21", height: "20", viewBox: "0 0 21 20", fill: "currentColor", ...props, children: /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.49408 3.57709C9.81951 3.25165 10.3472 3.25165 10.6726 3.57709L16.5059 9.41042C16.8314 9.73586 16.8314 10.2635 16.5059 10.5889L10.6726 16.4223C10.3472 16.7477 9.81951 16.7477 9.49408 16.4223C9.16864 16.0968 9.16864 15.5692 9.49408 15.2438L13.9048 10.833H5.08333C4.6231 10.833 4.25 10.4599 4.25 9.99967C4.25 9.53944 4.6231 9.16634 5.08333 9.16634H13.9048L9.49408 4.7556C9.16864 4.43016 9.16864 3.90252 9.49408 3.57709Z"
    }
  ) });
};

const fade_css_ts_vanilla = '';

var clsFadeIn = "wk_y1x8do2";
var clsFadeOut = "wk_y1x8do3";

const toastSlide_css_ts_vanilla = '';

var clsToastSlideIn = "wk_1jpwxhg2";
var clsToastSlideOut = "wk_1jpwxhg3";

const modalSlide_css_ts_vanilla = '';

var clsModalSlideIn = "wk_3li8yi2";
var clsModalSlideOut = "wk_3li8yi3";

const animationMap = {
  fade: [clsFadeOut, clsFadeIn],
  "toast-slide": [clsToastSlideOut, clsToastSlideIn],
  "modal-slide": [clsModalSlideOut, clsModalSlideIn]
};
const Transition = (props) => {
  const { in: show, children, variant = "fade", onExit } = props;
  const { className, onAnimationEnd, ...restProps } = children.props;
  const [isMounted, setIsMounted] = useState(show);
  useEffect(() => {
    if (show) {
      setIsMounted(true);
    }
  }, [show]);
  const onPlayEnd = (e) => {
    onAnimationEnd?.(e);
    if (!show) {
      onExit?.();
      setIsMounted(false);
    }
  };
  if (!isMounted) {
    return null;
  }
  return React.cloneElement(children, {
    className: cx(animationMap[variant][Number(show)], className),
    onAnimationEnd: onPlayEnd,
    ...restProps
  });
};

function generateMatrix(value, errorCorrectionLevel) {
  const arr = Array.prototype.slice.call(
    QRCodeUtil.create(value, { errorCorrectionLevel }).modules.data,
    0
  );
  const sqrt = Math.sqrt(arr.length);
  return arr.reduce(
    (rows, key, index) => (index % sqrt === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows,
    []
  );
}
function QRCode(props) {
  const { className, ecl = "M", clearSize = 40, size = 212, uri } = props;
  const dots = useMemo(() => {
    const dots2 = [];
    const matrix = generateMatrix(uri, ecl);
    const cellSize = size / matrix.length;
    const qrList = [
      { x: 0, y: 0 },
      { x: 1, y: 0 },
      { x: 0, y: 1 }
    ];
    qrList.forEach(({ x, y }) => {
      const x1 = (matrix.length - 7) * cellSize * x;
      const y1 = (matrix.length - 7) * cellSize * y;
      for (let i = 0; i < 3; i++) {
        const width = cellSize * (7 - i * 2);
        const r = [8, 4, 0][i];
        dots2.push(
          /* @__PURE__ */ jsx(
            "rect",
            {
              fill: i % 2 === 0 ? "var(--wk-colors-qrCodeDot)" : "var(--wk-colors-modalBackground)",
              height: width,
              width,
              rx: r,
              ry: r,
              x: x1 + cellSize * i,
              y: y1 + cellSize * i
            },
            `${i}-${x}-${y}`
          )
        );
      }
    });
    const clearArenaSize = Math.ceil(clearSize / cellSize) + 4;
    const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
    const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
    matrix.forEach((row, i) => {
      row.forEach((_, j) => {
        if (matrix[i][j]) {
          if (!(i < 7 && j < 7 || i > matrix.length - 8 && j < 7 || i < 7 && j > matrix.length - 8)) {
            if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) {
              dots2.push(
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    cx: i * cellSize + cellSize / 2,
                    cy: j * cellSize + cellSize / 2,
                    fill: "var(--wk-colors-qrCodeDot)",
                    r: cellSize / 3
                  },
                  `circle-${i}-${j}`
                )
              );
            }
          }
        }
      });
    });
    return dots2;
  }, [ecl, clearSize, size, uri]);
  return /* @__PURE__ */ jsx("svg", { className, height: "100%", width: "100%", viewBox: `0 0 ${size} ${size}`, children: dots });
}

const styles_css_ts_vanilla$f = '';

var clsContainer$5 = "wk_92eoeu1";
var clsCorner = "wk_92eoeu2";

function QRCodePlaceHolder() {
  return /* @__PURE__ */ jsxs(Box, { className: clsContainer$5, children: [
    /* @__PURE__ */ jsx(Box, { as: "span", className: clsCorner }),
    /* @__PURE__ */ jsx(Box, { as: "span", className: clsCorner }),
    /* @__PURE__ */ jsx(Box, { as: "span", className: clsCorner })
  ] });
}

const styles_css_ts_vanilla$e = '';

var clsQrCodeContainer = "wk_10yx5n50";
var clsQrCodeLogo = "wk_10yx5n52";
var clsQrCodeWrapper = "wk_10yx5n51";

function CustomQRCode(props) {
  const { className, logo, logoSize = 44, value, ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { className: cx("wk-qrcode", clsQrCodeContainer, className), ...restProps, children: /* @__PURE__ */ jsxs(Box, { className: clsQrCodeWrapper, children: [
    value ? /* @__PURE__ */ jsx(Transition, { in: !!value, children: /* @__PURE__ */ jsx(QRCode, { uri: value }) }) : /* @__PURE__ */ jsx(QRCodePlaceHolder, {}),
    /* @__PURE__ */ jsx(
      Box,
      {
        className: cx("wk-qrcode-logo", clsQrCodeLogo),
        style: {
          width: logoSize,
          height: logoSize,
          opacity: value ? 1 : 0.3
        },
        children: logo
      }
    )
  ] }) });
}

const styles_css_ts_vanilla$d = '';

var clsContainer$4 = "wk_1j0944g0";
var clsOfficialButton = "wk_1j0944g1";

function TemplateQRCodeView(props) {
  const { wallet, qrCodeUri, onClickOpenWcModal, isConnected, isWalletConnect, address } = props;
  const { options } = useWalletKit();
  const logos = useWalletLogos(wallet?.logos);
  useAutoCloseConnectModal(isConnected, address);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ModalHeader, { children: "Scan with your phone" }),
    /* @__PURE__ */ jsx(ModalBody, { className: cx("wk-scan-qrcode", clsContainer$4), children: /* @__PURE__ */ jsx(CustomQRCode, { value: qrCodeUri, logo: logos.default }) }),
    isWalletConnect && !options?.hideOfficialWalletConnectCTA && /* @__PURE__ */ jsx(ModalFooter, { children: /* @__PURE__ */ jsxs(
      Link,
      {
        className: cx("wk-official-wc-button", clsOfficialButton),
        onClick: onClickOpenWcModal,
        children: [
          "Open the official WalletConnect modal",
          /* @__PURE__ */ jsx(ForwardIcon, {})
        ]
      }
    ) })
  ] });
}

function useWalletConnectConnector() {
  const connectors = useConnectors();
  return connectors.find((item) => isWalletConnect(item.id));
}

function useWalletConnectUri(props = {}) {
  const { enabled = true, refreshUriOnError = true } = props;
  const { connectAsync } = useEvmConnect();
  const { log } = useWalletKit();
  const connector = useWalletConnectConnector();
  const isConnected = useIsConnected();
  const [wcUri, setWcUri] = useState();
  useEffect(() => {
    if (isConnected || !connector || !enabled)
      return;
    const onUpdateWcUri = ({ type, data }) => {
      if (type === "display_uri") {
        setWcUri(data);
      }
    };
    const connectWallet = async () => {
      try {
        log("[WcUri]", "connecting");
        const provider = await connector?.getProvider();
        provider.rpc.showQrModal = false;
        await connectAsync({ connector });
      } catch (error) {
        if (error?.code === 4001 && refreshUriOnError) {
          connectWallet();
        }
      }
    };
    connectWallet();
    connector.emitter.on("message", onUpdateWcUri);
    return () => {
      connector?.emitter.off("message", onUpdateWcUri);
    };
  }, [isConnected, enabled, refreshUriOnError]);
  return {
    wcUri
  };
}

function useWalletConnectModal() {
  const { connectAsync } = useEvmConnect();
  const connectModal = useConnectModal();
  const { log } = useWalletKit();
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        connectModal.onClose();
      }, 800);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [connectModal, isOpen]);
  const connector = useWalletConnectConnector();
  return {
    isOpen,
    onOpen: async () => {
      document.body.style.setProperty("--wcm-z-index", "2147483647");
      const provider = await connector?.getProvider();
      provider.rpc.showQrModal = true;
      if (connector) {
        setIsOpen(true);
        try {
          await connectAsync({ connector });
        } catch (err) {
          log("[OpenWcModal]", err);
        }
        setIsOpen(false);
      }
    }
  };
}

function EvmQRCodeView() {
  const { selectedWallet } = useWalletKit();
  const { wcUri } = useWalletConnectUri();
  const wcModal = useWalletConnectModal();
  const qrCodeUri = wcUri && (selectedWallet.getUri?.(wcUri) ?? wcUri);
  const isConnected = useIsConnected();
  const { address } = useAccount();
  return /* @__PURE__ */ jsx(
    TemplateQRCodeView,
    {
      wallet: selectedWallet,
      qrCodeUri,
      onClickOpenWcModal: wcModal.onOpen,
      isConnected,
      isWalletConnect: isWalletConnect(selectedWallet.id),
      address
    }
  );
}

function EvmUriConnectingView() {
  const { selectedWallet } = useWalletKit();
  const isConnected = useIsConnected();
  const { address } = useAccount();
  const { status, setStatus } = useConnectingStatus({
    initialStatus: CONNECT_STATUS.CONNECTING
  });
  const { wcUri } = useWalletConnectUri({
    enabled: status !== CONNECT_STATUS.CONNECTING,
    refreshUriOnError: false
  });
  const onTryAgain = () => {
    setStatus(CONNECT_STATUS.CONNECTING);
    const walletUri = selectedWallet.getUri(wcUri);
    openLink(walletUri);
  };
  return /* @__PURE__ */ jsx(
    TemplateConnectingView,
    {
      isConnected,
      status,
      runConnect: () => void 0,
      onTryAgain,
      wallet: selectedWallet,
      address
    }
  );
}

function useSolanaConnect() {
  const { solanaConfig } = useWalletKit();
  const { select, wallets: adapters, connected } = useWallet();
  const connect = useCallback(
    async ({ adapterName }) => {
      select(adapterName);
      if (!solanaConfig?.autoConnect) {
        const adapter = adapters.find((item) => item.adapter.name === adapterName)?.adapter;
        if (adapter) {
          await adapter.connect();
        }
      }
    },
    [adapters, select, solanaConfig?.autoConnect]
  );
  return {
    connect,
    isConnected: connected
  };
}

function solanaCommonErrorHandler(props) {
  const { log, handler, error } = props;
  if (error) {
    const description = error.message || error.name;
    log("[WalletError]", error);
    handler?.(error, description);
  }
}

function SolanaConnectingView() {
  const { log, selectedWallet, options } = useWalletKit();
  const [status, setStatus] = useState(
    selectedWallet.isInstalled() ? CONNECT_STATUS.CONNECTING : CONNECT_STATUS.UNAVAILABLE
  );
  const { isConnected, connect } = useSolanaConnect();
  const { publicKey } = useWallet();
  useEffect(() => {
    const onError = (error) => {
      let message = "";
      if (error.message.includes("Error Calling Method: requestAccounts") || error.message.includes("rejected")) {
        message = "User rejected the request";
        setStatus(CONNECT_STATUS.REJECTED);
      } else {
        setStatus(CONNECT_STATUS.FAILED);
      }
      solanaCommonErrorHandler({
        log,
        handler: options.onError,
        error: {
          message
        }
      });
    };
    EventEmitter.on(EventEmitter.SOLANA_WALLET_ERROR, onError);
    return () => {
      EventEmitter.off(EventEmitter.SOLANA_WALLET_ERROR, onError);
    };
  }, [options.onError, log]);
  const runConnect = useCallback(async () => {
    if (!selectedWallet.isInstalled())
      return;
    setStatus(CONNECT_STATUS.CONNECTING);
    connect({
      adapterName: selectedWallet.adapterName
    });
  }, [connect, selectedWallet]);
  return /* @__PURE__ */ jsx(
    TemplateConnectingView,
    {
      status,
      runConnect,
      onTryAgain: runConnect,
      wallet: selectedWallet,
      isConnected,
      address: publicKey?.toBase58()
    }
  );
}

function SolanaQRCodeView() {
  return null;
}

const MOBILE_MEDIA = "screen and (max-width: 767px)";

function useMediaQuery(query) {
  const [isMatched, setIsMatched] = useState(false);
  useEffect(() => {
    const onChange = () => {
      const isMatched2 = window.matchMedia(query).matches;
      setIsMatched(isMatched2);
    };
    onChange();
    const matchMedia = window.matchMedia(query);
    matchMedia.addEventListener("change", onChange);
    return () => {
      matchMedia.removeEventListener("change", onChange);
    };
  }, [query]);
  return isMatched;
}
const useResponsive = () => {
  const isMobileLayout = useMediaQuery(MOBILE_MEDIA);
  return {
    isMobileLayout
  };
};

const WalletIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", { width: 24, height: 24, viewBox: "0 0 40 40", fill: "currentColor", ...props, children: /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.16669 12.5C4.16669 9.73858 6.40526 7.5 9.16669 7.5H30.8334C33.5948 7.5 35.8334 9.73858 35.8334 12.5V27.5C35.8334 30.2614 33.5948 32.5 30.8334 32.5H9.16669C6.40526 32.5 4.16669 30.2614 4.16669 27.5V12.5ZM9.16669 10.8333C8.24621 10.8333 7.50002 11.5795 7.50002 12.5V27.5C7.50002 28.4205 8.24621 29.1667 9.16669 29.1667H30.8334C31.7538 29.1667 32.5 28.4205 32.5 27.5V26.4583H24.1667C20.5998 26.4583 17.7084 23.5668 17.7084 20C17.7084 16.4332 20.5998 13.5417 24.1667 13.5417H32.5V12.5C32.5 11.5795 31.7538 10.8333 30.8334 10.8333H9.16669ZM32.5 16.4583H24.1667C22.2107 16.4583 20.625 18.044 20.625 20C20.625 21.956 22.2107 23.5417 24.1667 23.5417H32.5V16.4583ZM26.6667 20C26.6667 21.1506 25.7339 22.0833 24.5834 22.0833C23.4328 22.0833 22.5 21.1506 22.5 20C22.5 18.8494 23.4328 17.9167 24.5834 17.9167C25.7339 17.9167 26.6667 18.8494 26.6667 20Z"
    }
  ) });
};

const styles_css_ts_vanilla$c = '';

var clsWalletOption$1 = "wk_1dbgl2y1";
var clsWalletOptionDisabled$1 = "wk_1dbgl2y4";
var clsWalletOptionIcon$1 = "wk_1dbgl2y3";
var clsWalletOptionName$1 = "wk_1dbgl2y2";
var clsWalletOptionWrapper = "wk_1dbgl2y0";

const Text = (props) => {
  const { ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { as: "p", ...restProps });
};
Text.displayName = "Text";

function useWalletRender(props) {
  const { wallet, layout, clickRef, defaultRender } = props;
  const { colorMode } = useTheme();
  const logos = useWalletLogos(wallet.logos);
  const renderOptions = {
    layout,
    colorMode,
    wallet: {
      id: wallet.id,
      walletType: wallet.walletType,
      name: wallet.name,
      logo: layout === "grid" ? logos.default : logos.transparent,
      isDisabled: wallet.isDisabled,
      isVisible: wallet.isVisible
    },
    onClick(e) {
      clickRef.current?.(wallet.id, e);
    }
  };
  const render = wallet.render ?? defaultRender;
  return render?.(renderOptions);
}

function SetEvmWalletClickRef(props) {
  const { clickRef } = props;
  const { log, options, evmConfig, setSelectedWallet } = useWalletKit();
  const { disconnect } = useDisconnect();
  const wcModal = useWalletConnectModal();
  const connectModal = useConnectModal();
  const router = useRouter();
  const timerRef = useRef();
  clickRef.current = (walletId, e) => {
    const wallet = evmConfig.wallets.find((item) => item.id === walletId);
    const pass = options.onClickWallet?.(wallet, e);
    if (pass === false)
      return;
    log("[ClickWallet]", `ethereum:`, typeof window.ethereum);
    log("[ClickWallet]", `installed:`, wallet.isInstalled());
    const jumpTo = (viewRoute) => {
      setSelectedWallet(wallet);
      if (connectModal.isOpen) {
        router.push(viewRoute);
      } else {
        connectModal.onOpen({
          viewRoute
        });
      }
    };
    const jumpToQRCodeView = () => {
      const qrCodeUri = wallet.getUri("xxx");
      if (qrCodeUri) {
        jumpTo(ViewRoutes.EVM_QRCODE);
      } else {
        options.onError?.(
          new Error(`The wallet does not support QR code`),
          `The wallet does not support QR code`
        );
      }
    };
    const jumpToConnectingView = () => {
      jumpTo(ViewRoutes.EVM_CONNECTING);
    };
    const jumpToDeepLink = () => {
      const deepLink = wallet.getDeepLink();
      if (deepLink) {
        openLink(deepLink);
      } else {
        options.onError?.(
          new Error(`The wallet does not support deeplink`),
          `The wallet does not support deeplink`
        );
      }
    };
    const jumpToUriConnectingView = () => {
      const wcUri = getEvmGlobalData().homeViewWalletConnectUri;
      if (wcUri) {
        const connectUri = wallet.getUri(wcUri);
        if (connectUri) {
          openLink(connectUri);
          jumpTo(ViewRoutes.EVM_URI_CONNECTING);
        } else {
          options.onError?.(
            new Error(`The wallet does not support URI connection`),
            `The wallet does not support URI connection`
          );
        }
      }
    };
    disconnect();
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (isTMA()) {
        if (isMobile()) {
          if (isWalletConnect(walletId)) {
            wcModal.onOpen();
          } else {
            jumpToUriConnectingView();
          }
        } else {
          jumpToQRCodeView();
        }
      } else if (isMobile()) {
        if (isWalletConnect(walletId)) {
          wcModal.onOpen();
        } else if (wallet.isInstalled()) {
          jumpToConnectingView();
        } else {
          jumpToDeepLink();
        }
      } else {
        if (isWalletConnect(walletId)) {
          if (wallet.showQRCode) {
            jumpToQRCodeView();
          } else {
            wcModal.onOpen();
          }
        } else if (wallet.showQRCode) {
          jumpToQRCodeView();
        } else {
          jumpToConnectingView();
        }
      }
    }, 300);
  };
  return null;
}

function SetSolanaWalletClickRef(props) {
  const { clickRef } = props;
  const { log, options, setSelectedWallet, solanaConfig } = useWalletKit();
  const { disconnect } = useWallet();
  const { connect } = useSolanaConnect();
  const connectModal = useConnectModal();
  const router = useRouter();
  const timerRef = useRef();
  clickRef.current = (walletId, e) => {
    const wallet = solanaConfig.wallets.find((item) => item.id === walletId);
    const pass = options.onClickWallet?.(wallet, e);
    if (pass === false)
      return;
    log("[ClickWallet]", `wallet:`, wallet);
    log("[ClickWallet]", `installed:`, wallet.isInstalled());
    const jumpTo = (viewRoute) => {
      setSelectedWallet(wallet);
      if (connectModal.isOpen) {
        router.push(viewRoute);
      } else {
        connectModal.onOpen({
          viewRoute
        });
      }
    };
    const jumpToConnectingView = () => {
      jumpTo(ViewRoutes.SOLANA_CONNECTING);
    };
    disconnect();
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (isMobile()) {
        const deeplink = wallet.getDeepLink();
        if (wallet.isInstalled()) {
          jumpToConnectingView();
        } else if (deeplink) {
          openLink(deeplink);
        } else {
          connect({
            adapterName: wallet.adapterName
          });
        }
      } else {
        jumpToConnectingView();
      }
    }, 300);
  };
  return null;
}

function useTronConnect() {
  const { select, wallets: adapters, connected } = useWallet$1();
  const [isConnected, setIsConnected] = useState(connected);
  const connect = useCallback(
    async ({ adapterName, chainId }) => {
      select(adapterName);
      const finalChainId = typeof chainId === "number" ? `0x${chainId.toString(16)}` : chainId;
      const adapter = adapters.find((item) => item.adapter.name === adapterName)?.adapter;
      if (adapter) {
        await adapter.connect();
        setIsConnected(true);
        if (finalChainId && !isMobile()) {
          await adapter?.switchChain(finalChainId);
        }
      }
    },
    [adapters, select]
  );
  return {
    connect,
    isConnected
  };
}

function SetTronWalletClickRef(props) {
  const { clickRef } = props;
  const { log, options, setSelectedWallet, tronConfig } = useWalletKit();
  const { disconnect } = useWallet$1();
  const { connect } = useTronConnect();
  const connectModal = useConnectModal();
  const router = useRouter();
  const timerRef = useRef();
  clickRef.current = (walletId, e) => {
    const wallet = tronConfig.wallets.find((item) => item.id === walletId);
    const pass = options.onClickWallet?.(wallet, e);
    if (pass === false)
      return;
    log("[ClickWallet]", `wallet:`, wallet);
    log("[ClickWallet]", `installed:`, wallet.isInstalled());
    const jumpTo = (viewRoute) => {
      setSelectedWallet(wallet);
      if (connectModal.isOpen) {
        router.push(viewRoute);
      } else {
        connectModal.onOpen({
          viewRoute
        });
      }
    };
    const jumpToConnectingView = () => {
      jumpTo(ViewRoutes.TRON_CONNECTING);
    };
    disconnect();
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (isMobile()) {
        if (wallet.isInstalled()) {
          jumpToConnectingView();
        } else {
          connect({
            adapterName: wallet.adapterName
          });
        }
      } else {
        jumpToConnectingView();
      }
    }, 300);
  };
  return null;
}

function SetWalletClickRef(props) {
  const { wallet, clickRef } = props;
  if (wallet.walletType === "evm") {
    return /* @__PURE__ */ jsx(SetEvmWalletClickRef, { clickRef });
  }
  if (wallet.walletType === "solana") {
    return /* @__PURE__ */ jsx(SetSolanaWalletClickRef, { clickRef });
  }
  if (wallet.walletType === "tron") {
    return /* @__PURE__ */ jsx(SetTronWalletClickRef, { clickRef });
  }
}

function WalletOption$1(props) {
  const { wallet } = props;
  const clickRef = useRef();
  const component = useWalletRender({
    wallet,
    layout: "grid",
    clickRef,
    defaultRender: ({ wallet: wallet2, onClick }) => {
      const { isDisabled, name, logo } = wallet2;
      return /* @__PURE__ */ jsx(Box, { className: cx("wk-wallet-option-wrapper", clsWalletOptionWrapper), children: /* @__PURE__ */ jsxs(
        Button,
        {
          className: cx(
            "wk-wallet-option",
            clsWalletOption$1,
            isDisabled ? clsWalletOptionDisabled$1 : void 0
          ),
          onClick: isDisabled ? void 0 : onClick,
          children: [
            /* @__PURE__ */ jsx(Box, { className: cx("wk-wallet-option-logo", clsWalletOptionIcon$1), children: logo }),
            /* @__PURE__ */ jsx(Text, { className: cx("wk-wallet-option-name", clsWalletOptionName$1), children: name })
          ]
        }
      ) });
    }
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SetWalletClickRef, { wallet, clickRef }),
    component
  ] });
}

const styles_css_ts_vanilla$b = '';

var clsNoWalletButton = "wk_cvot8n1";
var clsWallets$1 = "wk_cvot8n0";

function GridLayout(props) {
  const { visibleWallets } = props;
  const { options } = useWalletKit();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ModalBody, { className: cx("wk-wallets", clsWallets$1), "data-layout": "grid", children: visibleWallets?.map((w, index) => /* @__PURE__ */ jsx(WalletOption$1, { wallet: w }, index)) }),
    !options.hideNoWalletCTA && /* @__PURE__ */ jsx(ModalFooter, { children: /* @__PURE__ */ jsxs(
      Button,
      {
        as: "a",
        className: cx("wk-nowallet-button", clsNoWalletButton),
        href: options.walletDownloadUrl,
        target: "_blank",
        rel: "noopener",
        children: [
          /* @__PURE__ */ jsx(WalletIcon, {}),
          "I don’t have a wallet"
        ]
      }
    ) })
  ] });
}

const styles_css_ts_vanilla$a = '';

var clsNoWalletLink = "wk_1lg2shr1";
var clsWallets = "wk_1lg2shr0";

const styles_css_ts_vanilla$9 = '';

var clsWalletOption = "wk_713zwr0";
var clsWalletOptionDisabled = "wk_713zwr3";
var clsWalletOptionIcon = "wk_713zwr2";
var clsWalletOptionName = "wk_713zwr1";

function WalletOption(props) {
  const { wallet } = props;
  const clickRef = useRef();
  const component = useWalletRender({
    wallet,
    layout: "list",
    clickRef,
    defaultRender: ({ wallet: wallet2, onClick }) => {
      const { isDisabled, name, logo } = wallet2;
      return /* @__PURE__ */ jsxs(
        Button,
        {
          className: cx(
            "wk-wallet-option",
            clsWalletOption,
            isDisabled ? clsWalletOptionDisabled : void 0
          ),
          onClick: isDisabled ? void 0 : onClick,
          children: [
            /* @__PURE__ */ jsx(Text, { className: cx("wk-wallet-option-name", clsWalletOptionName), children: name }),
            /* @__PURE__ */ jsx(Box, { className: cx("wk-wallet-option-logo", clsWalletOptionIcon), children: logo })
          ]
        }
      );
    }
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SetWalletClickRef, { wallet, clickRef }),
    component
  ] });
}

function ListLayout(props) {
  const { visibleWallets } = props;
  const { options } = useWalletKit();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ModalBody, { className: cx("wk-wallets", clsWallets), "data-layout": "list", children: visibleWallets?.map((w, index) => /* @__PURE__ */ jsx(WalletOption, { wallet: w }, index)) }),
    !options.hideNoWalletCTA && /* @__PURE__ */ jsx(ModalFooter, { children: /* @__PURE__ */ jsxs(
      Link,
      {
        className: cx("wk-nowallet-link", clsNoWalletLink),
        href: options.walletDownloadUrl,
        children: [
          /* @__PURE__ */ jsx(WalletIcon, {}),
          "I don’t have a wallet"
        ]
      }
    ) })
  ] });
}

const styles_css_ts_vanilla$8 = '';

var clsDisclaimer = "wk_zqrn660";

function EvmHomeViewWalletConnectUriProvider() {
  const { wcUri } = useWalletConnectUri({
    refreshUriOnError: false
  });
  setEvmGlobalData({
    homeViewWalletConnectUri: wcUri
  });
  return null;
}

function HomeView() {
  const { wallets, options } = useWalletKit();
  const { isMobileLayout } = useResponsive();
  const visibleWallets = wallets.filter((item) => item.isVisible !== false);
  const useGridLayout = visibleWallets.length >= options.gridLayoutThreshold || isMobileLayout && options.useGridLayoutOnMobile;
  const needPreCreateWcUri = isTMA() && isMobile();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(ModalHeader, { children: options.title }),
    options.disclaimer && /* @__PURE__ */ jsx(Box, { className: cx("wk-disclaimer", clsDisclaimer), children: options.disclaimer }),
    useGridLayout ? /* @__PURE__ */ jsx(GridLayout, { visibleWallets }) : /* @__PURE__ */ jsx(ListLayout, { visibleWallets }),
    needPreCreateWcUri && /* @__PURE__ */ jsx(EvmHomeViewWalletConnectUriProvider, {})
  ] });
}

function tronCommonErrorHandler(props) {
  const { log, handler, error } = props;
  if (error) {
    const description = error.message || error.name;
    log("[WalletError]", error);
    handler?.(error, description);
  }
}

function TronConnectingView() {
  const { log, selectedWallet, options, tronConfig } = useWalletKit();
  const [status, setStatus] = useState(
    selectedWallet.isInstalled() ? CONNECT_STATUS.CONNECTING : CONNECT_STATUS.UNAVAILABLE
  );
  const { connect, isConnected } = useTronConnect();
  const { address } = useWallet$1();
  useEffect(() => {
    const onError = (error) => {
      let message = "";
      if (error.message.includes("rejected")) {
        message = "User rejected the request";
        setStatus(CONNECT_STATUS.REJECTED);
      } else {
        setStatus(CONNECT_STATUS.FAILED);
      }
      tronCommonErrorHandler({
        log,
        handler: options.onError,
        error: {
          message
        }
      });
    };
    EventEmitter.on(EventEmitter.TRON_WALLET_ERROR, onError);
    return () => {
      EventEmitter.off(EventEmitter.TRON_WALLET_ERROR, onError);
    };
  }, [options.onError, log]);
  const runConnect = useCallback(async () => {
    if (!selectedWallet.isInstalled())
      return;
    setStatus(CONNECT_STATUS.CONNECTING);
    connect({
      adapterName: selectedWallet.adapterName,
      chainId: tronConfig?.initialChainId
    });
  }, [connect, selectedWallet, tronConfig?.initialChainId]);
  return /* @__PURE__ */ jsx(
    TemplateConnectingView,
    {
      status,
      runConnect,
      onTryAgain: runConnect,
      wallet: selectedWallet,
      isConnected,
      address
    }
  );
}

var ViewRoutes = /* @__PURE__ */ ((ViewRoutes2) => {
  ViewRoutes2["HOME"] = "HOME";
  ViewRoutes2["EVM_CONNECTING"] = "EVM_CONNECTING";
  ViewRoutes2["EVM_QRCODE"] = "EVM_QRCODE";
  ViewRoutes2["EVM_URI_CONNECTING"] = "EVM_URI_CONNECTING";
  ViewRoutes2["SOLANA_CONNECTING"] = "SOLANA_CONNECTING";
  ViewRoutes2["SOLANA_QRCODE"] = "SOLANA_QRCODE";
  ViewRoutes2["TRON_CONNECTING"] = "TRON_CONNECTING";
  return ViewRoutes2;
})(ViewRoutes || {});
function RouteProvider(props) {
  const { children } = props;
  const [route, setRoute] = useState("");
  const { current: history } = useRef([]);
  const view = useMemo(() => {
    switch (route) {
      case "HOME" /* HOME */:
        return /* @__PURE__ */ jsx(HomeView, {});
      case "EVM_CONNECTING" /* EVM_CONNECTING */:
        return /* @__PURE__ */ jsx(EvmConnectingView, {});
      case "EVM_QRCODE" /* EVM_QRCODE */:
        return /* @__PURE__ */ jsx(EvmQRCodeView, {});
      case "EVM_URI_CONNECTING" /* EVM_URI_CONNECTING */:
        return /* @__PURE__ */ jsx(EvmUriConnectingView, {});
      case "SOLANA_CONNECTING" /* SOLANA_CONNECTING */:
        return /* @__PURE__ */ jsx(SolanaConnectingView, {});
      case "SOLANA_QRCODE" /* SOLANA_QRCODE */:
        return /* @__PURE__ */ jsx(SolanaQRCodeView, {});
      case "TRON_CONNECTING" /* TRON_CONNECTING */:
        return /* @__PURE__ */ jsx(TronConnectingView, {});
    }
    return null;
  }, [route]);
  const back = useCallback(() => {
    history.pop();
    const nextRoute = history[history.length - 1];
    if (nextRoute) {
      setRoute(nextRoute);
    }
  }, [history]);
  const push = useCallback(
    (nextRoute) => {
      if (nextRoute === "HOME" /* HOME */) {
        reset();
      }
      if (history[history.length - 1] !== nextRoute) {
        history.push(nextRoute);
        setRoute(nextRoute);
      }
    },
    [history]
  );
  const replace = useCallback(
    (nextRoute) => {
      if (history[history.length - 1] !== nextRoute) {
        history[history.length - 1] = nextRoute;
        setRoute(nextRoute);
      }
    },
    [history]
  );
  const reset = useCallback(() => {
    history.length = 0;
  }, [history]);
  const value = useMemo(() => {
    return {
      route,
      view,
      back,
      push,
      replace,
      reset,
      history
    };
  }, [back, history, view, push, replace, reset, route]);
  return /* @__PURE__ */ jsx(RouteContext.Provider, { value, children });
}

function useDisclosure() {
  const [isOpen, setIsOpen] = useState(false);
  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  return {
    isOpen,
    onOpen,
    onClose
  };
}

function ConnectModalProvider(props) {
  const { children } = props;
  const { setAction, evmConfig, tronConfig, options } = useWalletKit();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const router = useRouter();
  const value = useMemo(() => {
    return {
      isOpen,
      onClose() {
        onClose();
        setTimeout(() => {
          router.reset();
        }, 300);
      },
      onOpen(params = {}) {
        router.push(params.viewRoute ?? ViewRoutes.HOME);
        setAction(params.action);
        if (evmConfig && params.initialChainId) {
          evmConfig.initialChainId = params.initialChainId;
        }
        if (evmConfig && params.evmConfig?.initialChainId) {
          evmConfig.initialChainId = params.evmConfig.initialChainId;
        }
        if (tronConfig && params.tronConfig?.initialChainId) {
          tronConfig.initialChainId = params.tronConfig.initialChainId;
        }
        if (params.onConnected) {
          options.onConnected = params.onConnected;
        }
        onOpen();
      }
    };
  }, [evmConfig, isOpen, onClose, onOpen, options, router, setAction, tronConfig]);
  return /* @__PURE__ */ jsx(ConnectModalContext.Provider, { value, children });
}

const Portal = (props) => {
  const { children } = props;
  const portal = useRef();
  const [, forceUpdate] = useState({});
  useEffect(() => {
    const host = document.body;
    portal.current = document.createElement("div");
    portal.current.setAttribute("class", "wk-portal");
    host.appendChild(portal.current);
    forceUpdate({});
    const portalNode = portal.current;
    return () => {
      if (host.contains(portalNode)) {
        host.removeChild(portalNode);
      }
    };
  }, []);
  return portal.current ? createPortal(children, portal.current) : null;
};
Portal.displayName = "Portal";

const styles_css_ts_vanilla$7 = '';

var clsContainer$3 = "wk_1sntu031";
var clsDescWrapper = "wk_1sntu033";
var clsIconWrapper = "wk_1sntu032";
var clsToastRoot = "wk_1sntu030";

const ErrorIcon = (props) => {
  const errorColor = cssVar("error");
  return /* @__PURE__ */ jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 9.99999 18.3334C5.39762 18.3334 1.66666 14.6025 1.66666 10.0001C1.66666 5.39771 5.39762 1.66675 9.99999 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001Z",
        fill: errorColor
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5503 7.41394C13.8166 7.14767 13.8166 6.71597 13.5503 6.4497C13.284 6.18343 12.8523 6.18343 12.5861 6.4497L10 8.90372L7.41394 6.4497C7.14767 6.18343 6.71597 6.18343 6.4497 6.4497C6.18343 6.71597 6.18343 7.14767 6.4497 7.41394L8.90372 10L6.4497 12.5861C6.18343 12.8523 6.18343 13.284 6.4497 13.5503C6.71597 13.8166 7.14767 13.8166 7.41394 13.5503L10 11.0963L12.5861 13.5503C12.8523 13.8166 13.284 13.8166 13.5503 13.5503C13.8166 13.284 13.8166 12.8523 13.5503 12.5861L11.0963 10L13.5503 7.41394Z",
        fill: "white"
      }
    )
  ] });
};

const InfoIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 9.99999 18.3334C5.39762 18.3334 1.66666 14.6025 1.66666 10.0001C1.66666 5.39771 5.39762 1.66675 9.99999 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001Z",
        fill: "#5F8BFF"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "10", cy: "5.41675", r: "1.25", fill: "white" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10.579 7.55143L7.87065 7.8755C7.65964 7.89895 7.5 8.07731 7.5 8.28962V8.75002C7.5 8.98014 7.68931 9.15814 7.91392 9.20817C8.47131 9.33231 8.95833 9.73515 8.95833 10.4167V12.9167C8.95833 13.5982 8.47131 14.0011 7.91392 14.1252C7.68931 14.1752 7.5 14.3532 7.5 14.5834V15C7.5 15.2301 7.68655 15.4167 7.91667 15.4167H12.0833C12.3135 15.4167 12.5 15.2301 12.5 15V14.5834C12.5 14.3532 12.3107 14.1752 12.0861 14.1252C11.5287 14.0011 11.0417 13.5982 11.0417 12.9167V7.96525C11.0417 7.71691 10.8258 7.52401 10.579 7.55143Z",
        fill: "white"
      }
    )
  ] });
};

const iconMap = {
  info: /* @__PURE__ */ jsx(InfoIcon, {}),
  error: /* @__PURE__ */ jsx(ErrorIcon, {})
};
function ToastComponent(props) {
  const { variant = "info", description, duration, toastId } = props;
  const [show, setShow] = useState(true);
  const [delay, setDelay] = useState(duration);
  useEffect(() => {
    if (delay) {
      const timer = setTimeout(() => {
        setShow(false);
      }, delay);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [delay]);
  const onExit = () => {
    ToastManager.remove(toastId);
  };
  const onMouseEnter = () => {
    setDelay(void 0);
  };
  const onMouseLeave = () => {
    setDelay(duration);
  };
  return /* @__PURE__ */ jsx(Transition, { in: show, variant: "toast-slide", onExit, children: /* @__PURE__ */ jsx(Box, { className: "wk-toast", children: /* @__PURE__ */ jsxs(Box, { className: clsContainer$3, onMouseEnter, onMouseLeave, children: [
    /* @__PURE__ */ jsx(Box, { className: clsIconWrapper, children: iconMap[variant] }),
    /* @__PURE__ */ jsx(Box, { className: clsDescWrapper, children: description })
  ] }) }) });
}

const ToastProvider = () => {
  const [toastList, setToastList] = useState([]);
  useEffect(() => {
    const update = (newList) => {
      setToastList(newList);
    };
    ToastManager.subscribe(update);
    return () => {
      ToastManager.unsubscribe(update);
    };
  }, []);
  return /* @__PURE__ */ jsx(Fragment, { children: toastList.length > 0 && /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(Box, { className: cx("wk-toast-container", clsToastRoot), children: toastList.map((item) => /* @__PURE__ */ jsx(ToastComponent, { ...item }, item.toastId)) }) }) });
};
ToastProvider.displayName = "ToastProvider";

const ProfileModalContext = React.createContext({});

function ProfileModalProvider(props) {
  const { children } = props;
  const { isOpen, onClose, onOpen } = useDisclosure();
  const value = useMemo(() => {
    return {
      isOpen,
      onClose,
      onOpen
    };
  }, [isOpen, onClose, onOpen]);
  return /* @__PURE__ */ jsx(ProfileModalContext.Provider, { value, children });
}

function TronWalletProvider(props) {
  const { children } = props;
  const { tronConfig } = useWalletKit();
  useMemo(() => {
    try {
      if (typeof window !== "undefined" && !tronConfig?.autoConnect) {
        window.localStorage.removeItem("tronAdapterName");
      }
    } catch (err) {
      console.log(err);
    }
  }, [tronConfig?.autoConnect]);
  const onError = useCallback((error) => {
    EventEmitter.emit(EventEmitter.TRON_WALLET_ERROR, error);
  }, []);
  if (!tronConfig) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsx(
    WalletProvider$1,
    {
      adapters: tronConfig.adapters,
      autoConnect: false,
      onError,
      children
    }
  );
}

const SwitchNetworkModalContext = React.createContext({});
function useSwitchNetworkModal() {
  return useContext(SwitchNetworkModalContext);
}

function SwitchNetworkProvider(props) {
  const { children } = props;
  const [isClosable, setIsClosable] = useState(true);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { isConnected, chain } = useAccount();
  const chains = useChains();
  const { options } = useWalletKit();
  const isSupported = chains?.find((e) => e.id === chain?.id);
  const value = useMemo(() => {
    return {
      isClosable,
      isOpen,
      onClose() {
        onClose();
        setTimeout(() => {
          setIsClosable(true);
        }, 300);
      },
      onOpen(options2) {
        const { isClosable: isClosable2 = true } = options2 ?? {};
        if (isConnected) {
          setIsClosable(isClosable2);
          onOpen();
        } else {
          toast.info({
            description: "Please connect a wallet first."
          });
        }
      }
    };
  }, [isClosable, isConnected, isOpen, onClose, onOpen]);
  useEffect(() => {
    if (isConnected && options.openModalOnWrongNetwork) {
      const timer = setTimeout(() => {
        if (!isSupported) {
          value.onOpen({
            isClosable: false
          });
        }
      }, 300);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [isSupported, isConnected]);
  useEffect(() => {
    if (isConnected && !isSupported) {
      setIsClosable(true);
    }
  }, [isSupported, isConnected]);
  return /* @__PURE__ */ jsx(SwitchNetworkModalContext.Provider, { value, children });
}

function WalletKitProvider(props) {
  const { config, children, theme, mode, debugMode = false } = props;
  const finalConfig = useMemo(() => {
    const finalConfig2 = getDefaultConfig(config);
    const wallets2 = [];
    const evmWallets = finalConfig2.evmConfig?.wallets;
    const solanaWallets = finalConfig2.solanaConfig?.wallets;
    const tronWallets = finalConfig2.tronConfig?.wallets;
    if (evmWallets)
      wallets2.push(...evmWallets);
    if (solanaWallets)
      wallets2.push(...solanaWallets);
    if (tronWallets)
      wallets2.push(...tronWallets);
    return {
      ...finalConfig2,
      wallets: wallets2
    };
  }, [config]);
  const [action, setAction] = useState();
  const [selectedWallet, setSelectedWallet] = useState({});
  const [wallets, setWallets] = useState(finalConfig.wallets);
  const value = useMemo(() => {
    return {
      ...finalConfig,
      log: debugMode ? console.log : () => void 0,
      action,
      setAction,
      selectedWallet,
      setSelectedWallet,
      wallets,
      setWallets
    };
  }, [action, debugMode, finalConfig, selectedWallet, wallets]);
  return /* @__PURE__ */ jsx(WalletKitContext.Provider, { value, children: /* @__PURE__ */ jsxs(ThemeProvider, { mode, theme, children: [
    /* @__PURE__ */ jsx(ToastProvider, {}),
    /* @__PURE__ */ jsx(RouteProvider, { children: /* @__PURE__ */ jsx(EvmWalletProvider, { children: /* @__PURE__ */ jsx(SolanaWalletProvider, { children: /* @__PURE__ */ jsx(TronWalletProvider, { children: /* @__PURE__ */ jsx(ConnectModalProvider, { children: /* @__PURE__ */ jsx(ProfileModalProvider, { children: /* @__PURE__ */ jsx(SwitchNetworkProvider, { children }) }) }) }) }) }) })
  ] }) });
}

const style_css_ts_vanilla$1 = '';

var clsModalContent = "wk_1kzf8pa0";

function ModalContent(props) {
  const { className, ...restProps } = props;
  return /* @__PURE__ */ jsx(Box, { className: cx("wk-modal-content", clsModalContent, className), ...restProps });
}

const style_css_ts_vanilla = '';

var clsContent = "wk_6fxksu1";
var clsModal$1 = "wk_6fxksu0";

const styles_css_ts_vanilla$6 = '';

var clsIconButton = "wk_1bjpejd0";

const IconButton = (props) => {
  const { className, icon, ...restProps } = props;
  return /* @__PURE__ */ jsx(Button, { className: cx("wk-icon-button", clsIconButton, className), ...restProps, children: icon });
};
IconButton.displayName = "IconButton";

const BackIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", { width: "20", height: "20", viewBox: "0 0 40 40", fill: "currentColor", ...props, children: /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.5118 8.82165C25.1627 9.47253 25.1627 10.5278 24.5118 11.1787L15.6904 20.0002L24.5118 28.8217C25.1627 29.4725 25.1627 30.5278 24.5118 31.1787C23.861 31.8295 22.8057 31.8295 22.1548 31.1787L12.1548 21.1787C11.5039 20.5278 11.5039 19.4725 12.1548 18.8217L22.1548 8.82165C22.8057 8.17078 23.861 8.17078 24.5118 8.82165Z"
    }
  ) });
};

const CloseIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", { width: "20", height: "20", viewBox: "0 0 40 40", fill: "currentColor", ...props, children: /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0119 9.51184C11.361 8.86097 10.3057 8.86097 9.65484 9.51184C9.00397 10.1627 9.00397 11.218 9.65484 11.8689L17.643 19.857L9.51187 27.9882C8.86099 28.639 8.86099 29.6943 9.51187 30.3452C10.1627 30.9961 11.218 30.9961 11.8689 30.3452L20 22.214L27.9218 30.1358C28.5726 30.7867 29.6279 30.7867 30.2788 30.1358C30.9297 29.4849 30.9297 28.4296 30.2788 27.7788L22.357 19.857L30.1358 12.0783C30.7867 11.4274 30.7867 10.3721 30.1358 9.72123C29.4849 9.07036 28.4297 9.07036 27.7788 9.72123L20 17.5L12.0119 9.51184Z"
    }
  ) });
};

const styles_css_ts_vanilla$5 = '';

var clsNavbar = "wk_1nzgcmu0";

function Navbar(props) {
  const { className, showBack, showClose = true, onBack, onClose, ...restProps } = props;
  return /* @__PURE__ */ jsxs(Box, { className: cx("wk-navbar", clsNavbar, className), ...restProps, children: [
    showBack && /* @__PURE__ */ jsx(IconButton, { className: "wk-navbar-back-button", icon: /* @__PURE__ */ jsx(BackIcon, {}), onClick: onBack }),
    /* @__PURE__ */ jsx(Box, { style: { flex: 1 } }),
    showClose && /* @__PURE__ */ jsx(IconButton, { className: "wk-navbar-close-button", icon: /* @__PURE__ */ jsx(CloseIcon, {}), onClick: onClose })
  ] });
}

function EmbeddedConnectModal(props) {
  const { className, ...restProps } = props;
  const { view, back, history } = useRouter();
  const { onOpen } = useConnectModal();
  useEffect(() => {
    onOpen({
      viewRoute: ViewRoutes.HOME
    });
  }, []);
  return /* @__PURE__ */ jsx(Box, { className: cx("wk-embedded-connect-modal", clsModal$1, className), ...restProps, children: /* @__PURE__ */ jsxs(ModalContent, { className: clsContent, ...restProps, children: [
    /* @__PURE__ */ jsx(Navbar, { showBack: history.length > 1, showClose: false, onBack: back }),
    view
  ] }) });
}

function useKeyDown(props = {}) {
  const { key = "Enter", enabled = true, handler } = props;
  useEffect(() => {
    if (!enabled) {
      return;
    }
    const onKeyDown = (e) => {
      if (e.code === key) {
        handler?.();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [enabled, handler, key]);
}

function useScrollLock(isLocked = false) {
  useEffect(() => {
    if (!isLocked) {
      return;
    }
    const originalOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = originalOverflow;
    };
  }, [isLocked]);
}

const styles_css_ts_vanilla$4 = '';

var clsModal = "wk_3qg8ds0";
var clsModalOverlay = "wk_3qg8ds1";

function Modal(props) {
  const {
    className,
    isOpen,
    onClose,
    children,
    contentClassName,
    closeOnEsc = true,
    closeOnOverlayClick = true,
    ...restProps
  } = props;
  useKeyDown({
    key: "Escape",
    enabled: isOpen && closeOnEsc,
    handler() {
      onClose();
    }
  });
  useScrollLock(isOpen);
  const { isMobileLayout } = useResponsive();
  const { colorMode } = useTheme();
  return /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(Transition, { in: isOpen, variant: "fade", children: /* @__PURE__ */ jsxs(
    Box,
    {
      className: cx("wk-modal", clsModal, className),
      style: {
        colorScheme: colorMode
      },
      ...restProps,
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: cx("wk-modal-overlay", clsModalOverlay),
            onClick: () => closeOnOverlayClick && onClose()
          }
        ),
        /* @__PURE__ */ jsx(Transition, { in: isOpen, variant: isMobileLayout ? "modal-slide" : void 0, children: /* @__PURE__ */ jsx(ModalContent, { className: contentClassName, children }) })
      ]
    }
  ) }) });
}

function ConnectModal() {
  const { options } = useWalletKit();
  const { isOpen, onClose } = useConnectModal();
  const { view, history, back } = useRouter();
  const showBack = history.length > 1;
  return /* @__PURE__ */ jsxs(
    Modal,
    {
      className: "wk-connect-modal",
      isOpen,
      onClose,
      closeOnEsc: options?.closeModalOnEsc,
      closeOnOverlayClick: options?.closeModalOnOverlayClick,
      children: [
        /* @__PURE__ */ jsx(Navbar, { showBack, onBack: back, onClose }),
        view
      ]
    }
  );
}

function useEvmSwitchChain(props) {
  const { options, log } = useWalletKit();
  const result = useSwitchChain({
    ...props,
    mutation: {
      ...props?.mutation,
      onError(error, ...params) {
        evmCommonErrorHandler({
          log,
          handler: options.onError,
          error
        });
        props?.mutation?.onError?.(error, ...params);
      }
    }
  });
  return result;
}

const styles_css_ts_vanilla$3 = '';

var clsBody = "wk_13sj0t41";
var clsChains = "wk_13sj0t44";
var clsDescription = "wk_13sj0t43";
var clsFooter = "wk_13sj0t42";
var clsNoNavHeader = "wk_13sj0t40";
var clsOrSeparator = "wk_13sj0t45";

const styles_css_ts_vanilla$2 = '';

var clsContainer$2 = "wk_101w2wp0";
var clsLoading = "wk_101w2wp2";

const ChainSpinnerIcon = (props) => {
  const stopColor = cssVar("primaryActive");
  return /* @__PURE__ */ jsxs("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M2 19C2 9.61116 9.61116 2 19 2",
        stroke: "url(#paint0_linear_5519_81784)",
        strokeWidth: "3",
        strokeLinecap: "round"
      }
    ),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
      "linearGradient",
      {
        id: "paint0_linear_5519_81784",
        x1: "19",
        y1: "2",
        x2: "2",
        y2: "15.7619",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ jsx("stop", { stopColor }),
          /* @__PURE__ */ jsx("stop", { offset: "1", stopColor, stopOpacity: "0" })
        ]
      }
    ) })
  ] });
};

function ChainSpinner(props) {
  const { isLoading, className, children, ...restProps } = props;
  return /* @__PURE__ */ jsxs(Box, { className: cx("wk-chain-spinner", clsContainer$2, className), ...restProps, children: [
    isLoading && /* @__PURE__ */ jsx(ChainSpinnerIcon, { className: clsLoading }),
    /* @__PURE__ */ jsx(Box, { children })
  ] });
}

const styles_css_ts_vanilla$1 = '';

var clsChainOptionLogo = "wk_1cot7941";
var clsChainOptionName = "wk_1cot7942";
var clsConnectedTag = "wk_1cot7943";
var clsContainer$1 = "wk_1cot7940";

function ChainOption(props) {
  const { data, isLoading, isConnected, ...restProps } = props;
  return /* @__PURE__ */ jsxs(Button, { className: cx("wk-chain-option", clsContainer$1), ...restProps, children: [
    /* @__PURE__ */ jsx(ChainSpinner, { isLoading, children: /* @__PURE__ */ jsx(Box, { className: cx("wk-chain-option-logo", clsChainOptionLogo), children: data.logo }) }),
    /* @__PURE__ */ jsx(Box, { className: cx("wk-chain-option-name", clsChainOptionName), children: data.name }),
    isConnected && /* @__PURE__ */ jsx(Box, { className: clsConnectedTag, children: "Connected" })
  ] });
}

const styles_css_ts_vanilla = '';

var clsContainer = "wk_obzzr10";

const ExitIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", ...props, children: /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 3C5.61929 3 4.5 4.11929 4.5 5.5L4.5 18.5C4.5 19.8807 5.61929 21 7 21H12.5C13.8807 21 15 19.8807 15 18.5V17.5C15 16.9477 14.5523 16.5 14 16.5C13.4477 16.5 13 16.9477 13 17.5V18.5C13 18.7761 12.7761 19 12.5 19H7C6.72386 19 6.5 18.7761 6.5 18.5V5.5C6.5 5.22386 6.72386 5 7 5H12.5C12.7761 5 13 5.22386 13 5.5V6.5C13 7.05228 13.4477 7.5 14 7.5C14.5523 7.5 15 7.05228 15 6.5V5.5C15 4.11929 13.8807 3 12.5 3H7ZM18.2071 7.29289C17.8166 6.90237 17.1834 6.90237 16.7929 7.29289C16.4024 7.68342 16.4024 8.31658 16.7929 8.70711L19.25 11H11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13H19.25L16.7929 15.2929C16.4024 15.6834 16.4024 16.3166 16.7929 16.7071C17.1834 17.0976 17.8166 17.0976 18.2071 16.7071L22.2071 12.7071C22.5976 12.3166 22.5976 11.6834 22.2071 11.2929L18.2071 7.29289Z"
    }
  ) });
};

function useCloseAllModals() {
  const connectModal = useConnectModal();
  const switchNetworkModal = useSwitchNetworkModal();
  return {
    onCloseAllModals() {
      connectModal.onClose();
      switchNetworkModal.onClose();
    }
  };
}

function DisconnectButton(props) {
  const { className, ...restProps } = props;
  const { reset } = useConnect();
  const { disconnect } = useDisconnect();
  const { onCloseAllModals } = useCloseAllModals();
  const onDisconnect = () => {
    onCloseAllModals();
    setTimeout(() => {
      disconnect();
      reset();
    }, 100);
  };
  return /* @__PURE__ */ jsxs(
    Button,
    {
      className: cx("wk-disconnect-button", clsContainer, className),
      onClick: onDisconnect,
      ...restProps,
      children: [
        /* @__PURE__ */ jsx(ExitIcon, {}),
        "Disconnect"
      ]
    }
  );
}

const UnknownChainIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", { width: "44", height: "44", viewBox: "0 0 44 44", fill: "none", ...props, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.5611 8.12948C21.0082 7.90729 21.5007 7.79167 22 7.79167C22.4993 7.79167 22.9919 7.90729 23.439 8.12948L23.4408 8.1304L33.0387 12.9293C33.577 13.197 34.031 13.61 34.3478 14.121C34.6649 14.6323 34.833 15.2218 34.8333 15.8234V27.2595C34.833 27.8611 34.6649 28.4511 34.3478 28.9624C34.031 29.4733 33.578 29.8858 33.0398 30.1535L23.4411 34.9528C22.9919 35.1775 22.4963 35.2947 21.994 35.2947C21.4918 35.2947 20.9964 35.1777 20.5472 34.9529L10.9475 30.1531L10.9452 30.1519C10.4071 29.8808 9.95535 29.4646 9.6411 28.9504C9.32739 28.437 9.16312 27.8464 9.16673 27.2448L9.16675 27.2417L10.0004 27.2475H9.16673V27.2448V15.8239C9.16705 15.2223 9.33518 14.6322 9.65222 14.121C9.96906 13.61 10.4221 13.1976 10.9604 12.9298L20.5592 8.1304L20.5611 8.12948ZM21.3031 9.62267L11.8706 14.3389L22 19.4036L32.1294 14.3389L22.697 9.62267C22.4806 9.51531 22.2416 9.45905 22 9.45905C21.7585 9.45905 21.5194 9.51534 21.3031 9.62267ZM10.8341 15.8241C10.8341 15.7785 10.8362 15.733 10.8401 15.6878L21.1663 20.8509V33.3983L11.6955 28.6629C11.4352 28.5315 11.2159 28.3297 11.0638 28.0809C10.9116 27.8318 10.8321 27.5452 10.8341 27.2533L10.8341 27.2475V15.8241ZM22.8337 33.3923L32.2967 28.6608C32.5576 28.5312 32.7772 28.3313 32.9308 28.0836C33.0844 27.836 33.1658 27.5504 33.166 27.259V15.8243C33.1659 15.7786 33.1639 15.7331 33.1599 15.6878L22.8337 20.8509V33.3923Z",
        fill: "url(#paint0_linear_3546_7073)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.8341 15.8241C10.8341 15.7785 10.8362 15.733 10.8401 15.6878L21.1663 20.8509V33.3983L11.6955 28.6629C11.4352 28.5315 11.2159 28.3297 11.0638 28.0809C10.9116 27.8318 10.8321 27.5452 10.8341 27.2533L10.8341 27.2475V15.8241Z",
        fill: "url(#paint1_linear_3546_7073)",
        fillOpacity: "0.3"
      }
    ),
    /* @__PURE__ */ jsxs("defs", { children: [
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_3546_7073",
          x1: "22",
          y1: "7.79167",
          x2: "22",
          y2: "35.2947",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "black" }),
            /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "black", stopOpacity: "0.7" })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint1_linear_3546_7073",
          x1: "22",
          y1: "7.79167",
          x2: "22",
          y2: "35.2947",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "black" }),
            /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "black", stopOpacity: "0.7" })
          ]
        }
      )
    ] })
  ] });
};

function SwitchNetworkModal() {
  const { isClosable, isOpen, onClose } = useSwitchNetworkModal();
  const { log, options, evmConfig } = useWalletKit();
  const { chain } = useAccount();
  const chains = useChains();
  const isSupported = chains?.find((e) => e.id === chain?.id);
  const { isPending, switchChain, variables } = useEvmSwitchChain({
    mutation: {
      onSuccess() {
        if (options.closeModalAfterSwitchingNetwork) {
          onClose();
        }
      }
    }
  });
  console.log(variables);
  const onSwitchNetwork = (chainId) => {
    log("[switch network page]", "switchNetwork:", switchChain, ", isLoading:", isPending);
    if (switchChain && !isPending) {
      switchChain({ chainId });
    }
  };
  return /* @__PURE__ */ jsxs(
    Modal,
    {
      className: "wk-switch-network-modal",
      isOpen,
      onClose,
      closeOnEsc: isClosable ? options.closeModalOnEsc : false,
      closeOnOverlayClick: isClosable ? options.closeModalOnOverlayClick : false,
      children: [
        isClosable && /* @__PURE__ */ jsx(Navbar, { onClose }),
        /* @__PURE__ */ jsx(ModalHeader, { className: isClosable ? void 0 : clsNoNavHeader, children: "Switch Network" }),
        /* @__PURE__ */ jsxs(ModalBody, { className: clsBody, children: [
          !isSupported && /* @__PURE__ */ jsx(Box, { className: clsDescription, children: "This app does not support the current connected network. Switch or disconnect to continue." }),
          /* @__PURE__ */ jsx(Box, { className: cx("wk-chains", clsChains), children: chains?.map((item) => {
            const config = evmConfig?.chainDisplayConfigs?.find((e) => e.id === item.id);
            const defaultConfig = {
              id: item.id,
              name: config?.name ?? item.name,
              logo: config?.name ?? /* @__PURE__ */ jsx(UnknownChainIcon, {})
            };
            return /* @__PURE__ */ jsx(
              ChainOption,
              {
                data: config ?? defaultConfig,
                isLoading: isPending && variables?.chainId === item.id,
                isConnected: item.id === chain?.id,
                onClick: () => onSwitchNetwork(item.id)
              },
              item.id
            );
          }) }),
          /* @__PURE__ */ jsx(Box, { className: cx("wk-or-separator", clsOrSeparator), children: "or" })
        ] }),
        /* @__PURE__ */ jsx(ModalFooter, { className: clsFooter, children: /* @__PURE__ */ jsx(DisconnectButton, {}) })
      ]
    }
  );
}

export { ConnectModal, EmbeddedConnectModal, SwitchNetworkModal, WalletKitProvider, cssVar, cx, isIOS, isMobile, isTMA, rgba, useConnectModal, useSwitchNetworkModal, useWalletKit };
